// Add your custom JS here.

jQuery(document).ready(function ($) {
	jQuery('button').click( function(e) {
		jQuery('.collapse').collapse('hide');
	});
}); 

jQuery(function() {
  var sal = require('sal.js')
    sal({
		threshold: 0.001,
	});
});
